import { useCallback, useMemo, useEffect, useState } from 'react';

export const useNeedsAttentionForAdapter = ({ needsAttentionLocal, attentionBeaconAdapterProps: attentionBeaconAdapterPropsFromProps }) => {
  const { onAdapterNeedsAttentionChange: onAdapterNeedsAttentionChangeFromProps } = attentionBeaconAdapterPropsFromProps;
  const [needsAttentionFromAdapter, setNeedsAttentionFromAdapter] = useState(false);
  const onAdapterNeedsAttentionChange = useCallback((newNeedsAttention) => {
    setNeedsAttentionFromAdapter(newNeedsAttention);
  }, []);

  const needsAttention = needsAttentionLocal || needsAttentionFromAdapter;
  useEffect(() => {
    onAdapterNeedsAttentionChangeFromProps(needsAttention);
  }, [needsAttention, onAdapterNeedsAttentionChangeFromProps]);

  const attentionBeaconAdapterProps = useMemo(() => ({
    ...attentionBeaconAdapterPropsFromProps,
    onAdapterNeedsAttentionChange,
  }), [attentionBeaconAdapterPropsFromProps, onAdapterNeedsAttentionChange]);

  return { needsAttention, attentionBeaconAdapterProps };
};
